import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import AnalyticsRoundedIcon from '@mui/icons-material/AnalyticsRounded';
import BuildIcon from '@mui/icons-material/Build';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import BookIcon from '@mui/icons-material/Book';
import {
    Link as RouterLink,
} from 'react-router-dom';
import {useEffect, useState} from "react";

const mainListItems = [
  { text: 'Home', icon: <HomeRoundedIcon/> , href: 'dashboard' },
  { text: 'Analytics', icon: <AnalyticsRoundedIcon /> , href: 'analytics' },
  { text: 'Konfigurieren', icon: <BuildIcon />, href: 'config'},
  { text: 'Aktoren', icon: <AssignmentRoundedIcon />, href:'actorconfig' },
  { text: 'Benachrichtigungen', icon: <AssignmentRoundedIcon />, href:'alertconfig' },
  { text: 'Grow Plan', icon: <BookIcon />, href: 'grow_plan' },
  { text: 'Settings', icon: <SettingsRoundedIcon />, href: 'settings' },
  

];

const secondaryListItems = [

];

export default function MenuContent(props) {

  const [choosenindex,setChoosenIndex] = useState(0);

  useEffect(() => {
      switch (window.location.pathname.substring(window.location.pathname.lastIndexOf('/') + 1)) {
          case "dashboard":
              setChoosenIndex(0);
              break;
          case "analytics":
              setChoosenIndex(1);
              break;
          case "config":
              setChoosenIndex(2);
              break;
          case "actorconfig":
              setChoosenIndex(3);
              break;
          case "alertconfig":
              setChoosenIndex(4);
              break;
  }
});


  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>
      <List dense>
        {mainListItems.map((item, index) => (
          <ListItem key={index}  disablePadding sx={{ display: 'block' }}>
            <ListItemButton component ={RouterLink} to={item.href} index={index} selected={index === choosenindex} onClick={() => setChoosenIndex(index)}>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      <List dense>
        {secondaryListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }}>
            <ListItemButton component ={RouterLink} to={item.href} index={index} selected={index === choosenindex} onClick={() => setChoosenIndex(index)}>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
}
